import { render, staticRenderFns } from "./OpenRegistrationPageForm.vue?vue&type=template&id=2ad96b32"
import script from "./OpenRegistrationPageForm.vue?vue&type=script&lang=js"
export * from "./OpenRegistrationPageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports